import { toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderSlot as _renderSlot, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b9a7056"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "base-checkbox flex items-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "base-checkbox__checkmark" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("label", _hoisted_1, [
    _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
    _withDirectives(_createElementVNode("input", {
      class: "base-checkbox__input",
      type: "checkbox",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputValue) = $event))
    }, null, 512), [
      [_vModelCheckbox, _ctx.inputValue]
    ]),
    _hoisted_2,
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ]))
}